import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import { setEditorSaved } from "../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { Inline, Stack, Box } from "@atlaskit/primitives";
import { Label } from "@atlaskit/form";

const DEFAULT_BURST = "20";
const BURST = "burst";

const DEFAULT_SLEEP = "500";
const SLEEP = "sleepTime";

const RateLimit = ({ action }) => {
  const [burst, setBurst] = useState(action?.ratelimit?.burst || DEFAULT_BURST);
  const [sleepTime, setSleepTime] = useState(action?.ratelimit?.sleepTime || DEFAULT_SLEEP);
  const dispatch = useDispatch();

  useEffect(() => {
    // Update state only if action.ratelimit exists and values have changed
    if (action?.ratelimit) {
      if (action.ratelimit.burst !== burst) {
        setBurst(action.ratelimit.burst);
      }
      if (action.ratelimit.sleepTime !== sleepTime) {
        setSleepTime(sleepTime);
      }
    } else {
      setBurst(DEFAULT_BURST);
      setSleepTime(DEFAULT_SLEEP);
    }
  }, [action]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Only allow positive integers
    const parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue) || parsedValue < 0) {
      return; // Ignore invalid input
    }
    if (name === BURST && (parsedValue < 1 || parsedValue > 200)) {
      return; // Ignore invalid input
    }
    if (name === SLEEP && (parsedValue < 50 || parsedValue > 5000)) {
      return; // Ignore invalid input
    }

    // Update state and redux
    action.ratelimit = action.ratelimit ? action.ratelimit : {};
    action.ratelimit[name] = parsedValue;

    if (name === BURST) {
      setBurst(parsedValue.toString());
      action.ratelimit[SLEEP] = sleepTime;
    } else {
      setSleepTime(parsedValue.toString());
      action.ratelimit[BURST] = burst;
    }

    // Dispatch the action to update the editor saved state
    dispatch(setEditorSaved(false));
  };

  return (
    <>
      <div className="ihub-action-tab-description">
        <div>
          <b>Burst:</b> This value specifies the maximum number of consecutive calls allowed to external resources before a sleep period is
          introduced.
          <p>
            <b>Sleep Time: </b>This value defines the duration (in milliseconds) to wait between bursts of calls. This helps to ensure we stay within
            the rate limits imposed by external resources and avoid service disruptions.
          </p>
        </div>
        <p>
          <b>Example</b> If you set the 'Burst' value to 5 and the 'Sleep Time' value to 1000 (1 second), the application will make 5 calls to the
          external resource in succession, followed by a 1-second delay before making another 5 calls.
        </p>
      </div>
      <Stack space="space.500">
        <Inline space="space.100">
          <Box>
            <Label>Burst</Label>
            <Textfield name={BURST} value={burst} isCompact onChange={handleChange} />
            Integer between 1-200.
          </Box>
          <Box>
            <Label>Sleep Time</Label>
            <Textfield name={SLEEP} value={sleepTime} isCompact onChange={handleChange} />
            Time in milliseconds. Min sleeptime 50 milliseconds and Max sleeptime is 5000 milliseconds.
          </Box>
        </Inline>
      </Stack>
    </>
  );
};

export default RateLimit;
